import NoticiaList from '../components/noticias/NoticiaList';

export default function NoticiasPage() {
  return <NoticiaList />;
}